/**
 * i18n/index.js — Initialisation i18next (Vague 0 : infrastructure seule)
 *
 * Aucune clé n'est encore utilisée dans l'app : les locales démarrent VIDES
 * (cf. locales/fr.json et en.json = {}). L'application reste 100 % en français
 * hardcodé. L'extraction des libellés écran par écran commence en vague 1.
 *
 * Choix toolchain (cf. DECISIONS — i18n web) : i18next 23 / react-i18next 14 /
 * languagedetector 7. Les majeures supérieures (i18next 24+, react-i18next 15+)
 * exigent un peer `typescript ^5`, incompatible avec la toolchain CRA 5 /
 * TypeScript 4.9 (react-scripts 5.0.1). Versions pinnées en conséquence.
 *
 * Détection : localStorage d'abord (clé 'ekynair_lang'), puis langue navigateur.
 * Fallback et défaut : français.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ekynair_lang',
    },
    interpolation: {
      // React échappe déjà le rendu — pas de double échappement.
      escapeValue: false,
    },
    react: {
      // Ressources statiques importées (JSON) → pas de chargement async,
      // donc pas besoin de <Suspense>.
      useSuspense: false,
    },
  });

export default i18n;
